import { useMemo } from 'react';
import { getQuarterFromMonth, createQuarterlyData } from './useQuarterHelpers';

/**
 * Calcul des charges par type et total
 */
export function useChargesCalculations(charges) {
  const chargesByType = useMemo(() => {
    const result = {};

    charges.forEach(charge => {
      const type = charge.type;
      if (!result[type]) {
        result[type] = createQuarterlyData();
      }

      if (type === 'Annuelle') {
        const montantParTrimestre = charge.montant / 4;
        result[type].Q1 += montantParTrimestre;
        result[type].Q2 += montantParTrimestre;
        result[type].Q3 += montantParTrimestre;
        result[type].Q4 += montantParTrimestre;
      } else if (type === 'Trimestrielle') {
        result[type][charge.trimestre] += charge.montant;
      } else if (type === 'Mensuelle' || type === 'Exceptionnelle') {
        const quarter = getQuarterFromMonth(charge.mois);
        result[type][quarter] += charge.montant;
      }

      result[type].ANNUEL += charge.montant;
    });

    return result;
  }, [charges]);

  const totalCharges = useMemo(() => {
    const result = createQuarterlyData();

    Object.values(chargesByType).forEach(typeCharges => {
      result.Q1 += typeCharges.Q1;
      result.Q2 += typeCharges.Q2;
      result.Q3 += typeCharges.Q3;
      result.Q4 += typeCharges.Q4;
      result.ANNUEL += typeCharges.ANNUEL;
    });

    return result;
  }, [chargesByType]);

  return { chargesByType, totalCharges };
}
